module.exports = __webpack_public_path__ + "static/media/30x30-0.26626e67.png";